import { useMemo } from 'react';
import { useFormContext } from 'react-hook-form';

import { FOR_BANK_SECTIONS, FOR_BANK_SUB_SECTIONS } from 'constants/businessToolSections/forBank';
import { debounce } from 'lodash';

import useCheckSubSectionAccess from 'hooks/useCheckSubSectionAccess';

import { PERIODS_OPERATION_TYPES, summarizeSubtractPeriodValues } from 'components/BusinessToolForm/utils/helpers';

import { observedFields } from '../../utils/form';

export const useGetTotalAssetsCalculation = () => {
  const { setValue } = useFormContext();

  const canAccess = useCheckSubSectionAccess(
    FOR_BANK_SECTIONS.MARKETING_AND_SALES,
    FOR_BANK_SUB_SECTIONS.FOR_BANK_MARKETING_AND_SALES.SALES_PLAN,
  );

  const [totalAssetsFiled] = observedFields.totalAssets.setCalculatedValueFieldNames;

  const getTotalAssetsCalculationHandler = useMemo(
    () =>
      debounce((content) => {
        if (!canAccess) return;

        const assetsTotal = summarizeSubtractPeriodValues(content, PERIODS_OPERATION_TYPES.ADD);

        setValue(totalAssetsFiled, assetsTotal);
      }, 500),
     
    [],
  );

  return getTotalAssetsCalculationHandler;
};
